import { Injectable } from '@angular/core';
import { Router, CanActivate, CanActivateChild, RouterStateSnapshot ,ActivatedRouteSnapshot } from "@angular/router";
import { AuthService } from "./auth.service";

@Injectable()
export class AuthGuardService implements CanActivate, CanActivate {

  constructor(
     private authService: AuthService, 
     private router:Router 
    ) { }

  canActivate(route:ActivatedRouteSnapshot, state:RouterStateSnapshot): boolean{
    let url: string =state.url;
    if(this.authService.isUserLoggedIn()){
      return true;
    }
    this.authService.setRedirectUrl(url);
    this.router.navigate([ this.authService.getLoginUrl() ]);
    return false;
  }  


}



// WEBPACK FOOTER //
// D:/PROJECTS/Sokousoni/winda-dashboard/dashboard-winda-mvp/src/app/services/auth-guard.service.ts